import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { GlobalTheme, TileTheme} from "../../layouts/theme";
import { Theme } from "../contexts/themeContext.js";
import Card from "../card/card.js";
import CardHeader from "../card/cardHeader.js";
import CardContent from '@material-ui/core/CardContent';

export default function RdoAccountVisitationChart() {
    const tileClasses = TileTheme();
    const { theme } = useContext(Theme);
    const currentTheme = GlobalTheme[theme];

    return (<>
        <Link to={{ pathname: "/RdoAccountVisitationList" }}>
            <Card chart color="primary" className={tileClasses.cardLow} style={{ background: currentTheme.background, color: currentTheme.text, marginTop:'16px' }} >
                <CardContent className={tileClasses.cardContent}>
                    <CardHeader>
                        <div className={tileClasses.title}>RDO Account Visitation</div>
                    </CardHeader>
                </CardContent>
            </Card>
        </Link>
    </>
    );
}
